import Grid2 from '@thirdparty-framework/mui/material/Grid';
import { Box } from '@mui/material';
import { observer } from 'mobx-react';
import SJHeader from '@product-framework/components/SJFormHandler/SJHeader';
import { useNavigate, useParams } from 'react-router-dom';
import { Breadcrumb, useLocalization, useStore } from '@ui-framework/index';
import {
  Layout,
  StackablePageButtons,
  PageSection,
  useServiceJob,
  ServiceJobProvider,
  AvailabilitySlotTypeProvider,
  ServiceJobDispatchAndRescheduleOptionsProvider,
} from '@product-framework/index';
import { FormattedMessage } from 'react-intl';
import RescheduleHelper from '../../lib/RescheduleHelper';
import ServiceJobDispatchWizard from '../../components/DispatchWizard';

function ServiceJobRescheduleContent() {
  const { formatMessage } = useLocalization();
  const { serviceJob } = useServiceJob();
  const navigate = useNavigate();
  const store = useStore();

  const breadCrumb = RescheduleHelper.getBreadcrumb({
    formatMessage,
    navigate,
    store,
    serviceJob,
  });

  const stackablePageButtons = RescheduleHelper.getStackableButton({
    formatMessage,
    serviceJob,
    navigate,
  });

  return (
    <Box>
      <Grid2 container mb={1.5}>
        <Grid2 xs={12} md={6}>
          <Breadcrumb items={breadCrumb} />
        </Grid2>
        <Grid2 xs={12} md={6}>
          <StackablePageButtons buttons={stackablePageButtons} />
        </Grid2>
      </Grid2>
      <SJHeader formData={serviceJob} sx={{ marginBottom: '10px' }} />
      <PageSection
        label={
          <FormattedMessage
            id="RESCHEDULE_JOB"
            defaultMessage="Reschedule Job"
          />
        }>
        <ServiceJobDispatchWizard isRescheduleFlow />
      </PageSection>
    </Box>
  );
}

function ServiceJobReschedule() {
  const { id: pageId } = useParams();

  return (
    <Layout>
      <ServiceJobProvider serviceJobId={pageId}>
        <AvailabilitySlotTypeProvider>
          <ServiceJobDispatchAndRescheduleOptionsProvider isRescheduleFlow>
            <ServiceJobRescheduleContent />
          </ServiceJobDispatchAndRescheduleOptionsProvider>
        </AvailabilitySlotTypeProvider>
      </ServiceJobProvider>
    </Layout>
  );
}

export default observer(ServiceJobReschedule);
